import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Services } from '../../../../Services';
import { withRouter } from 'react-router-dom';
import Table from '../../../../../Components/Table'
import Loader from '../../../../../../Global/Loader';

class Documents extends Component {
  state = {
    url: '',
    loading: true,
    dataDocs: [],
    columns: [
      { label: "Descripción", key: "descripcion" },
      { label: "Tipo de inspección", key: "tipo_de_inspección" },
      { label: "Fecha", key: "time" },
      {
        label: "Visualizar", key: "", custom: (value) => (
          <i
            onClick={() => this.preview(value.path)}
            className="fa-2x mr-2 fas fa-search"
            style={{ color: "#297AB9", cursor: 'pointer' }}
          />
        )
      },
    ],
    fullLoader: false
  };

  componentDidMount() {
    this.getUrl();
  }


  preview = async (path) => {
    if (!path) return;

    this.setState({ fullLoader: false })

    try {
      const response = await axios.post(
        `${Services.Get_Doc_Export_ForId.path}/document/imagLogerdash`,
        { path }
      );

      const base64 = response.data.data;

      if (base64) {
        const imageUrl = `data:image/jpeg;base64,${base64}`;
        const newTab = window.open();
        newTab.document.write(`
        <html>
          <head>
            <title>Vista de imagen</title>
            <style>
              body {
                margin: 0;
                background-color: #000;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100vh;
              }
              img {
                max-width: 100vw;
                max-height: 100vh;
                width: auto;
                height: auto;
                object-fit: contain;
              }
            </style>
          </head>
          <body>
            <img src="${imageUrl}" alt="Imagen" />
          </body>
        </html>
      `);
        newTab.document.close();
      }
    } catch (error) {
      console.log("🚀 ~ Documents ~ preview= ~ error:", error)
    } finally {
      this.setState({ fullLoader: true });
    }
  };


  getUrl = async () => {
    const { id } = this.props.match.params;

    try {
      const { data } = await axios.get(
        `${Services.Get_Doc_Export_ForId.path}/document/documentHash/${id}`
      );

      this.setState({
        url: data?.data?.url || '',
      });

      this.getDocuments(data?.data?.data?.DOAduanaImpo || '')

    } catch (error) {
      console.warn("Error al obtener URL del documento:", error);
      this.setState({ loading: false });
    }
  };

  getDocuments = async (rawOrden) => {
    try {
      // const cleanedOrden = rawOrden.replace(/[^\d]/g, '').slice(0, -3);

      const response = await axios.post(
        `${Services.Get_Doc_Export_ForId.path}/document/infoLogerdash`,
        { num: rawOrden }
      );

      this.setState({
        dataDocs: response.data?.data || [],
        loading: false,
        fullLoader: true
      });
    } catch (error) {
      console.warn("Error al obtener documentos logísticos:", error);
      this.setState({ loading: false });
    }
  };

  render() {
    const { url, loading, columns, dataDocs, fullLoader } = this.state;
    return (
      <>
        <Loader hidden={fullLoader} />
        <Card className="myCard">
          <CardBody>
            <div className="row">
              {loading ? (
                <span style={{ fontSize: 18, margin: 20 }}>Cargando...</span>
              ) : url ? (
                <>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontSize: 18, margin: 20 }}
                    href={url}
                  >
                    Ver documentos
                  </a>
                  <div className='col-12'>
                    <Table
                      columns={columns}
                      data={dataDocs}
                      itemsByPage={30}
                      options={{
                        pagination: true,
                        search: true,
                        downloads: {
                          xlsx: false,
                          pdf: false,
                        },
                      }}
                    />
                  </div>
                </>
              ) : (
                <span style={{ fontSize: 18, margin: 20, color: 'red' }}>
                  Documento no disponible
                </span>
              )}
            </div>
          </CardBody>
        </Card>
      </>
    );
  }
}

export default withRouter(Documents);